import { memo, type SVGProps } from 'react'

const SvgGrafana = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="grafana_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
  >
    <defs id="grafana_svg__defs54">
      <clipPath id="grafana_svg__SVGID_2_">
        <use
          xlinkHref="#grafana_svg__SVGID_1_"
          style={{
            overflow: 'visible',
          }}
          id="grafana_svg__use7"
          x={0}
          y={0}
          width="100%"
          height="100%"
        />
      </clipPath>
      <clipPath id="grafana_svg__SVGID_6_">
        <use
          height="100%"
          width="100%"
          y={0}
          x={0}
          id="grafana_svg__use35"
          style={{
            overflow: 'visible',
          }}
          xlinkHref="#grafana_svg__SVGID_5_"
        />
      </clipPath>
      <clipPath id="grafana_svg__SVGID_4_">
        <use
          height="100%"
          width="100%"
          y={0}
          x={0}
          id="grafana_svg__use13"
          style={{
            overflow: 'visible',
          }}
          xlinkHref="#grafana_svg__SVGID_3_"
        />
      </clipPath>
      <defs id="grafana_svg__defs5">
        <path id="grafana_svg__SVGID_1_" d="M-849.7-1412.2h4355.2V4224H-849.7z" />
      </defs>
      <defs id="grafana_svg__defs33">
        <path
          d="M1229.6 328.6s-.7 2.9-1.6 7.8c-8.3 2.4-16.6 4.7-24.9 7.4-11.5 3.5-22.8 7.7-34.3 11.8-11.3 4.4-22.8 8.8-34 13.8-22.6 9.7-45 20.6-66.9 32.9-21.2 11.9-42.1 25-62.4 39.2-2.9-1.4-5.2-2.4-5.2-2.4-207.3-79.2-391.4 16.1-391.4 16.1-16.8 220.5 82.8 359.5 102.5 384.7-4.9 13.6-9.5 27.4-13.7 41.3-15.3 50-26.8 101.3-33.9 154.3-1 7.6-1.9 15.3-2.8 23-191.5 94.6-248.3 288.5-248.3 288.5C572.6 1530.9 759 1542.3 759 1542.3c.2-.1.3-.3.5-.4 23.7 42.3 51.1 82.6 82 120.1 12.9 15.7 26.5 30.9 40.6 45.6-58.3 166.7 8.2 305.4 8.2 305.4 178 6.7 294.9-77.9 319.5-97.4 17.7 6 35.7 11.3 53.8 16 54.7 14.1 110.7 22.4 166.7 24.8 14 .6 28 .9 41.9.8h6.8l4.4-.1 8.8-.3 8.7-.4.2.3c83.8 119.6 231.3 136.5 231.3 136.5 104.9-110.6 110.9-220.3 110.9-244v-1.6c0-2-.1-3.3-.1-3.3-.1-1.7-.1-3.3-.3-5.1 22-15.4 43-32 62.9-49.8 42-38 78.7-81.2 109.1-127.9 2.9-4.4 5.7-8.8 8.4-13.3 118.7 6.8 202.4-73.5 202.4-73.5-19.7-123.7-90.2-184-104.9-195.4 0 0-.6-.5-1.5-1.1-.8-.6-1.4-1-1.4-1-.7-.5-1.6-1.1-2.6-1.7.7-7.5 1.4-14.9 1.8-22.3.9-13.3 1.2-26.7 1.3-39.9l-.1-9.9-.1-5v-2.5c0-3.4-.1-2.1-.1-3.4l-.4-8.3-.6-11.2c-.2-3.9-.5-7.2-.8-10.7-.3-3.4-.6-6.9-1-10.3l-1.2-10.3-1.4-10.2c-2-13.6-4.6-27.1-7.7-40.4-12.4-53.3-33.2-103.9-60.7-149.4s-61.7-85.8-100.2-119.7c-38.5-34-81.7-61.3-127-81.7-45.3-20.4-92.9-33.5-140.3-39.5-23.7-3.1-47.3-4.3-70.7-4l-8.7.2-2.2.1c-.6 0-3.3.1-3 .1l-3.6.2-8.7.6c-3.3.2-6.7.5-9.6.8-12 1.2-23.9 2.8-35.7 5-47 8.8-91.4 25.8-130.5 49.2-39.1 23.4-73.1 52.7-100.8 85.9-27.6 33.1-49.1 69.8-63.9 107.8-14.8 38-23.1 77.2-25.4 115.3-.6 9.5-.8 19-.6 28.4 0 2.3.1 4.7.2 7l.3 7.6c.3 4.6.7 9.1 1.1 13.6 1.9 19.3 5.4 37.8 10.6 55.7 10.3 35.7 26.9 68 47.3 95.4 20.4 27.5 44.8 50.2 70.7 67.9 25.9 17.7 53.6 30.4 81 38.5 27.5 8.1 54.8 11.6 80.5 11.5 3.2 0 6.4-.1 9.6-.2 1.7 0 3.4-.2 5.1-.2l5.1-.3c2.7-.3 5.5-.5 8.2-.8.6 0 1.5-.2 2.3-.3l2.5-.3c1.7-.2 3.3-.5 5-.7 3.4-.4 6.3-1.1 9.3-1.6 3-.6 6-1.2 9-2 5.9-1.3 11.6-3.1 17.3-4.8 11.2-3.7 21.7-8.2 31.5-13.2s18.8-10.7 27.2-16.6c2.4-1.7 4.7-3.5 7-5.3 9-7 10.4-20.2 3.2-29-6.3-7.7-17.1-9.7-25.7-4.9-2.1 1.2-4.3 2.3-6.5 3.4-7.5 3.6-15.3 7-23.6 9.7-8.3 2.6-16.9 4.8-25.9 6.4-4.5.6-9 1.3-13.6 1.7-2.3.3-4.6.4-7 .4-2.3.1-4.8.3-6.9.2-2.2 0-4.4-.1-6.7-.1-2.8-.1-5.6-.3-8.4-.4 0 0-1.4 0-.3-.1l-.9-.1-1.9-.2c-1.3-.1-2.5-.2-3.8-.4-2.5-.3-5-.6-7.5-1-20.1-2.8-40.5-8.7-60.1-17.6-19.7-8.9-38.5-21.1-55.5-36.4-17-15.2-31.8-33.6-43.4-54.4-11.6-20.7-19.7-43.8-23.5-68-1.9-12.1-2.7-24.6-2.4-36.8.2-3.4.3-6.7.5-10.1 0 .9.1-.5.1-.6l.1-1.2.2-2.5c.1-1.7.3-3.3.5-5 .7-6.6 1.7-13.3 2.9-19.8 9.3-52.7 35.7-104.1 76.5-143.2 10.2-9.7 21.2-18.8 32.9-26.8s24.2-15.2 37.2-21.2c13-6 26.6-10.9 40.5-14.7 13.9-3.7 28.2-6.2 42.7-7.5a263 263 0 0 1 21.8-.9c1.9 0 3.4.1 4.9.1l5.9.2 3.7.1c1.5 0 0 0 .7.1l1.5.1 5.9.4c15.7 1.3 31.4 3.5 46.8 7 30.9 6.9 60.9 18.2 88.9 33.7 56 31 103.7 79.5 133 138 14.8 29.1 25 60.5 30.2 92.9 1.2 8.1 2.2 16.3 2.9 24.5l.5 6.2.3 6.2c.1 2.1.1 4.1.2 6.2 0 2 .1 4.3.1 5.8v5.3l-.1 6c-.2 4-.5 10.5-.7 14.5-.7 8.9-1.4 17.9-2.6 26.8-1.1 8.8-2.6 17.6-4.2 26.4-1.8 8.7-3.6 17.4-5.9 26-4.3 17.3-9.9 34.2-16.4 50.8-13.1 33.2-30.6 64.7-51.7 93.8-42.3 58.1-100 105.6-165.6 135.4-32.8 14.8-67.4 25.7-103 31.6-17.8 3-35.8 4.8-53.8 5.4l-3.3.1h-2.9l-5.8.1h-13.3c2.5 0-.4 0-.3-.1l-1.8-.1c-9.7-.2-19.3-.7-28.9-1.4-38.5-2.9-76.6-9.7-113.5-20.5-36.9-10.7-72.7-25-106.6-43-67.7-36.2-128.2-85.8-175.6-145.6-23.8-29.8-44.6-61.8-61.8-95.5-17.2-33.7-30.7-69-40.7-105.1-9.9-36.1-16.1-73.1-18.5-110.3l-.4-7-.1-1.7v-1.5l-.1-3.1-.2-6.1-.1-1.5v-6.4l-.1-8.7V1140.6c0-4.5.2-9.1.3-13.6.7-18.4 2.2-37.3 4.6-56.2 2.4-18.9 5.5-37.9 9.4-56.8 3.9-18.8 8.5-37.5 13.7-55.8 10.5-36.7 23.6-72.3 39.1-105.9 31.1-67.3 71.9-126.6 120.9-174.4 12.2-12 24.9-23.3 38.1-33.9 13.2-10.6 26.9-20.4 41-29.6 14-9.3 28.5-17.7 43.4-25.5 7.4-4 15-7.5 22.6-11.2 3.8-1.7 7.7-3.4 11.5-5.1 3.8-1.7 7.7-3.4 11.6-4.9 15.5-6.6 31.5-12.1 47.5-17.3 4.1-1.2 8.1-2.5 12.1-3.7 4-1.3 8.2-2.2 12.2-3.4 8.1-2.3 16.4-4.2 24.6-6.3 4.1-1.1 8.3-1.8 12.4-2.7 4.2-.9 8.3-1.8 12.5-2.6 4.2-.8 8.4-1.5 12.5-2.3l6.3-1.1 6.3-1c4.2-.6 8.4-1.3 12.6-1.9 4.7-.8 9.5-1.2 14.2-1.9 3.9-.5 10.2-1.2 14.1-1.7 3-.3 5.9-.6 8.9-.9l5.9-.6 3-.3 3.5-.2c4.8-.3 9.5-.6 14.3-.9l7.1-.5s2.6-.1.3-.1l1.5-.1 3-.1c4.1-.2 8.1-.4 12.2-.6 16.2-.5 32.3-.5 48.2 0 31.9 1.3 63.2 4.8 93.6 10.4 60.9 11.3 118.2 30.9 170 56.5 51.9 25.4 98.4 56.6 138.8 90.5 2.5 2.1 5 4.3 7.5 6.4 2.5 2.2 4.9 4.3 7.3 6.5 4.9 4.3 9.6 8.8 14.3 13.1 4.7 4.4 9.2 8.9 13.8 13.3 4.4 4.5 8.9 8.9 13.2 13.5 17.1 18.1 33 36.5 47.3 55 28.7 36.9 51.6 74.1 69.9 109.3 1.2 2.2 2.3 4.4 3.4 6.6 1.1 2.2 2.2 4.4 3.2 6.6 2.1 4.3 4.3 8.6 6.2 12.9 2 4.3 4 8.5 5.9 12.7 1.8 4.2 3.6 8.4 5.4 12.4 6.8 16.5 13 32.1 18.1 47 8.4 23.9 14.5 45.5 19.3 64.2 1.9 7.5 9 12.5 16.7 11.8 8-.7 14.1-7.3 14.3-15.3.4-20.1-.1-43.8-2.4-70.8-3-33.4-8.7-72.1-20-114.6-11.1-42.5-27.6-89-51.6-137.3-24.1-48.2-55.5-98.4-96.3-146.9-15.9-19-33.3-37.8-52.1-56.1 28-111.4-34.1-208-34.1-208-107.2-6.7-175.4 33.3-200.7 51.6-4.2-1.8-8.5-3.6-12.8-5.4-18.3-7.4-37-14.3-56.3-20.4-19.3-6.1-39-11.7-59.1-16.4-20.2-4.7-40.7-8.7-61.6-11.9-3.7-.5-7.3-1-11-1.6-46.6-149.4-180.9-211.9-180.9-211.9-149.8 94.5-178.3 227.4-178.3 227.4"
          id="grafana_svg__SVGID_5_"
        />
      </defs>
      <defs id="grafana_svg__defs11">
        <path id="grafana_svg__SVGID_3_" d="M-849.7-1412.2h4355.2V4224H-849.7z" />
      </defs>
      <linearGradient
        gradientTransform="matrix(0 -255.7742 -255.7742 0 2099115.5 -207133.55)"
        y2={8201.71}
        x2={-812.649}
        y1={8201.71}
        x1={-819.765}
        gradientUnits="userSpaceOnUse"
        id="grafana_svg__SVGID_7_"
      >
        <stop
          id="grafana_svg__stop38"
          style={{
            stopColor: '#fff200',
          }}
          offset={0}
        />
        <stop
          id="grafana_svg__stop40"
          style={{
            stopColor: '#f15a29',
          }}
          offset={1}
        />
      </linearGradient>
    </defs>
    <style type="text/css" id="style2">
      {
        '.grafana_svg__st0{fill:#c59a6e}.grafana_svg__st1{fill:#3cb44b}.grafana_svg__st2{fill:#67308f}.grafana_svg__st3{fill:#d1d1d1}.grafana_svg__st4{fill:#ef5b28}.grafana_svg__st5{stroke:#000;stroke-width:16;stroke-miterlimit:10}.grafana_svg__st6{fill:url(#grafana_svg__Triangle-3_1_)}.grafana_svg__st7{fill:#333}.grafana_svg__st8{fill:#cf2129}.grafana_svg__st9{fill:#cc3832}.grafana_svg__st10{fill:#ba443d}.grafana_svg__st11{fill:#bac556}.grafana_svg__st12{fill:#f8df4b}.grafana_svg__st13{fill:#f5cf47}.grafana_svg__st14{fill:#a9b75d}.grafana_svg__st15{fill:#ddbe5b}.grafana_svg__st16{fill:#6fbecb}.grafana_svg__st17{fill:#79c0bf}.grafana_svg__st18{fill:#77c3d2}.grafana_svg__st19{fill:#5cb8bb}.grafana_svg__st20{fill:#529fb5}.grafana_svg__st21{fill:#ba3d36}.grafana_svg__st22{fill:#9d3634}.grafana_svg__st23{fill:#d33e35}.grafana_svg__st24{fill:#869b63}.grafana_svg__st25{fill:#bec54f}.grafana_svg__st26{fill:#9ead59}.grafana_svg__st27{fill:none}.grafana_svg__st28{fill:#43ae2a}.grafana_svg__st29{fill:#009ddd}.grafana_svg__st30{fill:#00a297}.grafana_svg__st31{fill:#0072cc}.grafana_svg__st32{fill:#82bb00}.grafana_svg__st33{fill:#10069d}.grafana_svg__st34{fill:#333f48}.grafana_svg__st35{clip-path:url(#grafana_svg__SVGID_2_)}.grafana_svg__st36{clip-path:url(#grafana_svg__SVGID_4_);fill:#414042}'
      }
    </style>
    <g id="grafana_svg__g937" transform="translate(-57.832 129.719) scale(.81591)">
      <path
        transform="matrix(.03938 0 0 .03938 57.733 -162.971)"
        clipPath="url(#grafana_svg__SVGID_6_)"
        id="grafana_svg__rect43"
        style={{
          fill: 'url(#grafana_svg__SVGID_7_)',
          clipPath: 'url(#grafana_svg__SVGID_6_)',
        }}
        d="M412.7 100.8h1834.4v1992.3H412.7z"
      />
    </g>
  </svg>
)
const Memo = memo(SvgGrafana)
export default Memo
